import React from 'react';
export function CO2AdvantagesSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 space-y-6" data-id="element-1497">
      <h2 className="text-2xl md:text-3xl font-bold text-navy border-b border-gray-200 pb-4" data-id="element-1498">
        Advantages of CO2 Lasers
      </h2>
      <div className="space-y-6 text-gray-700 text-lg" data-id="element-1499">
        <div data-id="element-1500">
          <h3 className="font-bold text-navy mb-2" data-id="element-1501">
            Works well with thicker materials
          </h3>
          <p data-id="element-1502">
            Fiber lasers can work with thicker materials no problem, but
            generally a CO2 laser will leave a surface finish that is smoother.
          </p>
        </div>
        <div data-id="element-1503">
          <h3 className="font-bold text-navy mb-2" data-id="element-1504">
            Faster in a straight line
          </h3>
          <p data-id="element-1505">
            A CO2 laser is faster at cutting in a straight line, as well as
            having a quicker piercing time when the cut is first started.
          </p>
        </div>
      </div>
    </div>;
}